module.exports = __webpack_public_path__ + "media/react/marketing/pages/gre/home/sections/features/assets/drills_feature-c12a79cbc515708d12f23d95567c75ac.png";